export const ENVIRONMENT = {
  production: false,
  useDesignsystem: true,
  mockEnabled: false,
  serverPublicKeyNotification:
    'BFlqgFOCNuRj-6bXfFBPjqJUePAmGwvWMARgimo6JkK5ZrJC4eevQ6SkW8rg66BuoKWPwix58YYoMatXG0-HdW4',
  domain: '.leal.co',
  urls: {
    baseAPI: 'https://apidev.leal.co',
    lealCustomComponents: 'http://localhost:3333/build/leal-components-library',
    api: 'https://apidev.leal.co/v1/crm/api',
    amplitude: 'https://lealmain.leal.co/test/growth/events/v2',
    fastData: {
      api: 'https://apidataqa.leal.co/record',
      partitionKey: 'Leal360',
      streamName: 'DatadomainFastDataQa-insights-datastream',
    },
  },
  amplify: {
    domain: 'qacmleal.auth.us-east-1.amazoncognito.com',
    awsUserPoolsId: 'us-east-1_56ljFngJi',
    awsUserPoolsWebClientId: '7mbur3nq4hsqtnn1s5qu0dub54',
  },
  login: {
    url: 'https://devlogin.leal.co/',
    showOldLogin: false,
  },
  unleash:{
    url:'https://cloud.leal.co/unleash/api/frontend',
    clientKey:'*:default.bdaad0e9d91a943b8c26d458a3c31a0cff8b943badb6a876cd98e17a',
    appName:'shell',
    environment:'development'
  },
  clarityProjectId: '',
  featureFlags: {
    showDownloadComponent: false,
  }
};
